<script>
import {
  layoutMethods,
  esellerMethods,
  digitalLoadMethods,
  erpUserRolesMethods
} from "@/state/helpers";
import Swal from "sweetalert2";
// import Multiselect from "vue-multiselect";
import ImageUploader from "@/components/ImageUploader";
import { getModuleAccess } from '@/router/helper.js'

/**
 * Add eload Banner form component
 */
export default {
  page: {
    title: "E-load Banner Form",
  },
  data() {
    return {
      title: "E-load Banner Form",
      folder:"eload-banner",
      bannerId: 0,
      isEditModal: false,
      bannerLogo: {
        filename: null,
        type: null,
        base64: null,
      },
      banner: {
        id: null,
        name: "",
        image_src: "",
        status: 0,
        sequence: null
      },
      bannerSequence:[],
      bannerForm:{
        sequence : false,
      },
      isSubmitted: false,
      submitProgress: '',
      formExitChecker: {
        id: null,
        name: "",
        image_src: "",
        status: 0,
        sequence: null
      },
      eloadBannerModule: {
          access: {
            create: true,
            update: true,
          }
        }
    };
  },
  components: {
    // Multiselect,
    ImageUploader,
  },
  methods: {
    ...layoutMethods,
    ...esellerMethods,
    ...digitalLoadMethods,
    ...erpUserRolesMethods,
    checkForm() {
      if(this.banner.status == 1){
        if(this.banner.sequence == null){
          this.bannerForm.sequence = true;
          return;
        }
      }
      this.isSubmitted = true;
      if (this.isEditModal) {
        this.updateBanner();
      } else {
        this.createBanner();
      }
    },
    clearLogo() {
      this.bannerLogo = {
        filename: null,
        type: null,
        base64: null,
      };
    },
    createBanner() {
      this.submitProgress = "Uploading Image"
      var bannerObj = { ...this.banner };
      delete bannerObj.id;

      if (this.bannerLogo.base64) {
        var bannerLogo = { ...this.bannerLogo };
        bannerLogo.folder = this.folder;

        this.uploadLogo(bannerLogo)
          .then((imageKey) => {
            bannerObj = {
              ...bannerObj,
              bannerImageSrc: imageKey,
            };

            this.create(bannerObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.create(bannerObj);
      }
    },
    create(bannerObj) {
      this.submitProgress = "Saving Eload Banner";
      console.log(">>> create this:", bannerObj)
      this.createEloadBanner(bannerObj)
        .then(() => {
          this.submitProgress = "";
          this.isSubmitted = false;
          Swal.fire(
            "Create Successful!",
            `${bannerObj.name} has been created.`,
            "success"
          );
          // this.clearLogo();
          // this.clearForm();
          this.formExitChecker = this.banner;
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "E-Load Banner",
            }
          );
        })
        .catch((e) => {
          this.submitProgress = "";
          this.isSubmitted = false;
          console.log("Err::",e);
          Swal.fire(
            "Create Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${bannerObj.name} was not created.`,
            "error"
          );
          // this.clearLogo();
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    editBanner(bannerId) {
      this.logoPreview = null;
      this.getEloadBannerInfo(bannerId).then((itemData) => {
        console.log("hey");
        for(let data of this.bannerSequence){
          console.log(itemData.sequence == data.value,itemData.sequence, data.value)
          if(itemData.sequence == data.value && itemData.status == 0){
            if(data.disabled){
              itemData.sequence = null;
            }
          }
        }
        this.banner = { ...itemData };
        this.formExitChecker = { ...itemData };
        this.isEditModal = true;
      });
    },
    async sequenceOpt(){
      this.getEloadBannerSequenceList({}).then((itemData) => {
        this.bannerSequence = itemData
        if (this.bannerId > 0) {
          this.editBanner(this.bannerId);
        }
      });
    },
    updateBanner() {
      var bannerObj = { ...this.banner };
      bannerObj.id = bannerObj.id.toString();

      if (this.bannerLogo.base64) {
        this.submitProgress = "Uploading Image"
        var bannerLogo = { ...this.bannerLogo };
        bannerLogo.folder = this.folder;

        this.uploadLogo(bannerLogo)
          .then((imageKey) => {
            bannerObj = {
              ...bannerObj,
              bannerImageSrc: imageKey,
            };

            this.update(bannerObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        bannerObj.bannerImageSrc = bannerObj.image_src;
        this.update(bannerObj);
      }
    },
    update(bannerObj) {
      this.submitProgress = "Updating Eload Banner";
      this.updateEloadBanner(bannerObj)
        .then(() => {
          // this.isEditModal = false;
          this.submitProgress = "";
          this.isSubmitted = false;
          Swal.fire(
            "Update Successful!",
            `${bannerObj.name} has been updated.`,
            "success"
          );
          // this.clearLogo();
          this.formExitChecker = this.banner;
          // this.clearForm();
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "E-Load Banner",
            }
          );
        })
        .catch(() => {
          // this.isEditModal = false;
          this.submitProgress = "";
          this.isSubmitted = false;
          Swal.fire(
            "Update Failed!",
            `${bannerObj.name} was not updated.`,
            "error"
          );
          // this.clearLogo();
        });
    },
    leaveform(next){
        if(JSON.stringify(this.banner) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        } else {
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
        }

    },
    clearForm(){
      this.banner = {
        id: null,
        name: "",
        image_src: this.isEditModal ? this.banner.image_src : '',
        status: 0,
        sequence: null
      };
      this.formExitChecker = this.banner;
    }
  },
  async mounted() {
    await this.sequenceOpt();
    this.bannerId = this.$route.params.id;
    this.changeTitle({
      title: (this.bannerId > 0 ? "Update" : "Add") + " E-load Banner",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'Digital Load', to: { name: 'Digital Load'} },
        { text: 'E-Load Banner', to: { name: 'E-Load Banner'} },
        { text: "Form", to: { name: "E-load Banner Form" } },
      ],
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eLoad', 'eLoad Banner')
      .then((access) => this.eloadBannerModule.access = access);
      
  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
      console.log("><><><><> HEY",this.redirectForm,JSON.stringify(this.banner),JSON.stringify(this.formExitChecker));
      // console.log(">> next:", next)
      this.leaveform(next);
  }
};
</script>

<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              class="me-4"
              v-model="bannerLogo"
              :isRequired="true"
              :imageSrc="banner.bannerImageSrc"
            />
          </div>
          <!-- end of img upload-->
          
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="max-width: 620px">
                <div class="row">
                  <label v-if="(bannerId <= 0 || isNaN(bannerId)) && !eloadBannerModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a banner.</label>
                  <label v-else-if="bannerId > 0 && !eloadBannerModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a banner.</label>    
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        v-model="banner.status"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexSwitchCheckDefault"
                        >Active</label
                      >
                    </div>
                  </div>
                  <!--end of brand status-->

                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Banner Name <span style="color: red">*</span></label>
                    <validation-provider
                      name="Banner name"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Enter banner name"
                        :state="getValidationState(validationContext)"
                        v-model="banner.name"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of brand name-->

                  <div class="col-md-12 mb-3" v-if="banner.status == 1">
                    <label class="form-label small fw-bold">Sequence <span style="color: red">*</span></label>
                    <validation-provider
                      name="Sequence"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <template>
                        <b-form-select
                          v-model="banner.sequence"
                          :options="bannerSequence"
                          class="form-select mb-3 shadow-none"
                          :state="getValidationState(validationContext)"
                        >
                          <template #first>
                            <b-form-select-option :value="null" disabled
                              >Select Sequence Number</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </template>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>

                  <div class="col-md-12" v-if="banner.status == 0">
                    <label class="form-label small fw-bold">Sequence</label>
                    <template>
                      <b-form-select
                        v-model="banner.sequence"
                        :options="bannerSequence"
                        class="form-select mb-3 shadow-none"
                      >
                        <template #first>
                          <b-form-select-option :value="null" disabled
                            >Select Sequence Number</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </template>
                  </div><!--end of sequence-->

                  <div class="col-md-6 mt-3" v-if="!isSubmitted">
                    <b-button
                      :disabled="bannerId > 0 ? !eloadBannerModule.access.update : !eloadBannerModule.access.create"
                      variant="primary"
                      class="w-sm w-100p"
                      type="submit"
                      >{{isEditModal ? "Update":"Save"}}</b-button
                    >
                  </div>
                  <div class="col-md-6 mt-3" v-if="!isSubmitted">
                    <router-link
                      :to="{ name: 'E-Load Banner', params: {} }"
                      class="tc-white"
                    >
                      <b-button
                        variant="light"
                        class="w-sm w-100p"
                        type="button"
                        >Cancel</b-button
                      >
                    </router-link>
                  </div>
                  <div class="col-md-6 mt-3" v-if="isSubmitted">
                    {{submitProgress}}
                  </div>
                </div>
              </div>
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> </ValidationObserver
    ><!-- end of validation observer-->
  </div>
  <!-- end of row-->
</template>


<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}
</style>